import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-billing-day',
  templateUrl: './billing-day.component.html',
  styleUrls: ['./billing-day.component.css']
})
export class BillingDayComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  topTooltipExcel: string = 'Download .xlsx';

  percentage: any = [];
  loading: boolean = true;

  titleSunday: any;
  titleMonday: any;
  titleTuesday: any;
  titleWednesday: any;
  titleThursday: any;
  titleFriday: any;
  titleSaturday: any;

  valueSunday: any;
  valueMonday: any;
  valueTuesday: any;
  valueWednesday: any;
  valueThursday: any;
  valueFriday: any;
  valueSaturday: any;

  dataMax: any;
  dataMin: any;
  ex: any;
  errorApi = false;

  constructor(private el: ElementRef, private api: ApiService) { }

  ngOnInit() {
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.clearItens();
    if (item.branch != undefined) {
      this.salePweekDay(item).subscribe(data => {
        try {
          let excelInfo = [];
          let diaSemana = '';
          if (data.dataRow.length != 0) {
            data.dataRow.map((el: any) => {
              if (el.saledatetime_weekday == 1) {
                diaSemana = 'Domingo';
              } else if (el.saledatetime_weekday == 2) {
                diaSemana = 'Segunda-Feira';
              } else if (el.saledatetime_weekday == 3) {
                diaSemana = 'Terça-Feira';
              } else if (el.saledatetime_weekday == 4) {
                diaSemana = 'Quarta-Feira';
              } else if (el.saledatetime_weekday == 5) {
                diaSemana = 'Quinta-Feira';
              } else if (el.saledatetime_weekday == 6) {
                diaSemana = 'Sexta-Feira';
              } else if (el.saledatetime_weekday == 7) {
                diaSemana = 'Sábado';
              } else {
                diaSemana = '---';
              }
              this.percentage.push({percentage: el.percentage_value, dayofweek: el.saledatetime_weekday});
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Dia da Semana': diaSemana, 'Valor': el.percentage_value.toString() + '%'});
            });
            excelInfo.unshift({});
            localStorage.setItem('billing-day', JSON.stringify(excelInfo));
            this.biggestPercentage();
            this.errorApi = false;
          } else {
            this.errorApi = true;
            this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_BILLING_DAY);
          }
          this.loading = false;
        } catch (error: unknown) {
          this.clearItens();
          this.loading = false;
          this.errorApi = true;
          this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_ERRO_BILLING_DAY);
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
      });
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataBellingDay = [];
    let objectBellingDay = localStorage.getItem('billing-day');

    objectBellingDay != null
      ? (dataBellingDay = JSON.parse(objectBellingDay))
      : (dataBellingDay = []);
    const worksheetBellingDay= XLSX.utils.json_to_sheet(dataBellingDay);

    const workbook = {
      Sheets: {
        'percentual-medio-faturado-dia': worksheetBellingDay,
      },
      SheetNames: [
        'percentual-medio-faturado-dia',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-percentual-medio-faturado-dia' + EXCEL_EXTENSION);
  }

  salePweekDay(item: any) {
    return this.api.postWeekdays(item.dataMin, item.dataMax, item.branch, item.sellers);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: billing-day \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

  clearItens() {
    this.percentage = [];
    // Sunday
    this.titleSunday = this.el.nativeElement.querySelector('.title-billing-day-sunday');
    this.valueSunday = this.el.nativeElement.querySelector('.value-billing-day-sunday');
    this.titleSunday.classList.remove('selected');
    this.valueSunday.classList.remove('selected');
    // Monday
    this.titleMonday = this.el.nativeElement.querySelector('.title-billing-day-monday');
    this.valueMonday = this.el.nativeElement.querySelector('.value-billing-day-monday');
    this.titleMonday.classList.remove('selected');
    this.valueMonday.classList.remove('selected');
    // Tuesday
    this.titleTuesday = this.el.nativeElement.querySelector('.title-billing-day-tuesday');
    this.valueTuesday = this.el.nativeElement.querySelector('.value-billing-day-tuesday');
    this.titleTuesday.classList.remove('selected');
    this.valueTuesday.classList.remove('selected');
    // Wednesday
    this.titleWednesday = this.el.nativeElement.querySelector('.title-billing-day-wednesday');
    this.valueWednesday = this.el.nativeElement.querySelector('.value-billing-day-wednesday');
    this.titleWednesday.classList.remove('selected');
    this.valueWednesday.classList.remove('selected');
    // Thursday
    this.titleThursday = this.el.nativeElement.querySelector('.title-billing-day-thursday');
    this.valueThursday = this.el.nativeElement.querySelector('.value-billing-day-thursday');
    this.titleThursday.classList.remove('selected');
    this.valueThursday.classList.remove('selected');
    // Friday
    this.titleFriday = this.el.nativeElement.querySelector('.title-billing-day-friday');
    this.valueFriday = this.el.nativeElement.querySelector('.value-billing-day-friday');
    this.titleFriday.classList.remove('selected');
    this.valueFriday.classList.remove('selected');
    // Saturday
    this.titleSaturday = this.el.nativeElement.querySelector('.title-billing-day-saturday');
    this.valueSaturday = this.el.nativeElement.querySelector('.value-billing-day-saturday');
    this.titleSaturday.classList.remove('selected');
    this.valueSaturday.classList.remove('selected');
  }

  biggestPercentage() {
    let infoPercentage: any = [];
    this.percentage.map((el: any) => {
      infoPercentage.push(el.percentage);
    })
    let biggestPercentageItem = infoPercentage.reduce((a: any, b: any) => {
      return Math.max(a, b);
    });
    
    this.percentage.map((el: any) => {
      if ((el.percentage === biggestPercentageItem) && (el.percentage != 0)) {
        if (el.dayofweek == 1) {
          this.titleSunday.classList.add('selected');
          this.valueSunday.classList.add('selected');
        } else if (el.dayofweek == 2) {
          this.titleMonday.classList.add('selected');
          this.valueMonday.classList.add('selected');
        } else if (el.dayofweek == 3) {
          this.titleTuesday.classList.add('selected');
          this.valueTuesday.classList.add('selected');
        } else if (el.dayofweek == 4) {
          this.titleWednesday.classList.add('selected');
          this.valueWednesday.classList.add('selected');
        } else if (el.dayofweek == 5) {
          this.titleThursday.classList.add('selected');
          this.valueThursday.classList.add('selected');
        } else if (el.dayofweek == 6) {
          this.titleFriday.classList.add('selected');
          this.valueFriday.classList.add('selected');
        } else if (el.dayofweek == 7) {
          this.titleSaturday.classList.add('selected');
          this.valueSaturday.classList.add('selected');
        }
      }
    });
  }

}
